import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaArrowUp,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";

import logo from "../assets/customerSupport.webp";
import "../pages/Home.css";

const Footer = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer className="footer-main">
        <div className="footer-bg"></div>

        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-column">
              <img src={logo} alt="Customer Supports 24x7" className="footer-logo-img" />

              <p className="description">
                Expert appliance repair service with same-day doorstep support and trusted technicians.
              </p>

              <div className="social-row">
                <span className="social-icon" aria-hidden="true">
                  <FaFacebookF />
                </span>
                <span className="social-icon" aria-hidden="true">
                  <FaInstagram />
                </span>
                <span className="social-icon" aria-hidden="true">
                  <FaTwitter />
                </span>
              </div>
            </div>

            <div className="footer-column quick-links">
              <h4>Quick Links</h4>
              <ul>
                <li><NavLink to="/" onClick={goTop}>Home</NavLink></li>
                <li><NavLink to="/about" onClick={goTop}>About</NavLink></li>
                <li><NavLink to="/services" onClick={goTop}>Services</NavLink></li>
                <li><NavLink to="/contact" onClick={goTop}>Contact</NavLink></li>
              </ul>
            </div>

            <div className="footer-column services-links">
              <h4>Services</h4>
              <ul>
                <li><Link to="/services" onClick={goTop}>Washing Machine</Link></li>
                <li><Link to="/services" onClick={goTop}>Refrigerator</Link></li>
                <li><Link to="/services" onClick={goTop}>AC Repair</Link></li>
                <li><Link to="/services" onClick={goTop}>Water Purifier</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Contact</h4>

              <div className="contact-link">
                <FaPhoneAlt className="blue-icon" />
                <a href="tel:8050731754">8050731754</a>
              </div>

              <div className="contact-link">
                <FaEnvelope className="blue-icon" />
                <a href="mailto:info@customersupport24x7.in">info@customersupport24x7.in</a>
              </div>

              <div className="contact-link">
                <FaMapMarkerAlt className="blue-icon" />
                Bangalore, India
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-left">
              <Link to="/privacy-policy" onClick={goTop}>Privacy Policy</Link>
              <span className="divider">|</span>
              <Link to="/terms" onClick={goTop}>Terms & Conditions</Link>
              <span className="divider">|</span>
            
            </div>

            <div className="footer-right">
              Copyright 2026 Appliance Repair | Designed & Hosted By Web Universals.
            </div>
          </div>
        </div>

        <a
          href="https://wa.me/8050731754"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn floating-whatsapp-btn"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp />
        </a>

        <a href="tel:8050731754" className="floating-btn floating-call-btn" aria-label="Call now">
          <FaPhoneAlt />
        </a>

        <div className="sticky-cta">
          <a href="tel:8050731754">
            <FaPhoneAlt /> Call
          </a>
          <a href="https://wa.me/8050731754">
            <FaWhatsapp /> WhatsApp
          </a>
        </div>

        {showButton && (
          <button className="back-to-top" onClick={goTop} aria-label="Back to top">
            <FaArrowUp />
          </button>
        )}
      </footer>
    </>
  );
};

export default Footer;
